import { useContext } from 'react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'

//contexts
import AuthContext from 'context/AuthContext'
import LoaderContext from 'context/LoaderContext'
//constants
import { LOCAL_STORAGE, ERROR_TEXT } from 'constants/index'
//hooks
import useLocalStorage from 'hooks/useLocalStorage'
//services
import { orderGiftCard } from 'services/ordersService'
//types
import { OrderGiftCardRequestBody } from 'types'
//utils
import { handleError } from 'utils/utils'

const useOrderGiftCardMutation = () => {
  const { user, updateUserData } = useContext(AuthContext)
  const { showLoader, hideLoader } = useContext(LoaderContext)
  const navigate = useNavigate()
  const { setItem, removeItem } = useLocalStorage()

  const { mutate: orderGiftCardMutate } = useMutation(
    ({ giftCardId, denomination }: OrderGiftCardRequestBody) =>
      orderGiftCard({ giftCardId, denomination }),
    {
      onMutate: () => {
        showLoader()
      },
      onSuccess: (res) => {
        setItem(
          LOCAL_STORAGE.BALANCE_BEFORE_GIFT_CARD_REDEMPTION,
          JSON.stringify({ coins: user?.points, piggyBanks: user?.piggyBanks })
        )
        updateUserData(res.data.updatedUser)
        removeItem(LOCAL_STORAGE.GIFT_CARD_ID)
        removeItem(LOCAL_STORAGE.GIFT_CARD_DENOMINATION)
        navigate(`/order/${res.data.orderId}/success`)
      },
      onError: (err) => {
        handleError(err, ERROR_TEXT.choose_gift_card)
        navigate('/rewards')
      },
      onSettled: () => {
        hideLoader()
      },
    }
  )

  return { createOrderMutate: orderGiftCardMutate }
}

export default useOrderGiftCardMutation
